/**
 * WallEditor - Component for editing exterior wall properties in Manual J room data
 */

import React from 'react';
import { Select, NumberInput } from '../ui/Input';
import { Button } from '../ui/Button';
import {
  WALL_CONSTRUCTION_TYPES,
  WALL_INSULATION_OPTIONS,
  DIRECTIONS,
} from '../../constants/manualJOptions';

export default function WallEditor({ wall, onUpdate, onDelete, index, isAutoDetected = false }) {
  return (
    <div className="wall-editor" style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>
          Wall {index + 1}
          {isAutoDetected && <span style={styles.autoTag}>Auto</span>}
        </span>
        {!isAutoDetected && (
          <Button
            variant="ghost"
            size="small"
            onClick={onDelete}
            style={styles.deleteBtn}
          >
            Delete
          </Button>
        )}
      </div>

      <div style={styles.row}>
        <NumberInput
          label="Length (ft)"
          value={wall.length}
          onChange={(length) => onUpdate({ ...wall, length: parseFloat(length) || 0 })}
          min={1}
          max={200}
          step={0.5}
          style={styles.lengthInput}
          disabled={isAutoDetected}
        />
        <Select
          label="Facing"
          value={wall.facing}
          onChange={(facing) => onUpdate({ ...wall, facing })}
          options={DIRECTIONS}
          style={styles.directionSelect}
        />
      </div>

      <div style={styles.row}>
        <Select
          label="Construction"
          value={wall.construction}
          onChange={(construction) => onUpdate({ ...wall, construction })}
          options={WALL_CONSTRUCTION_TYPES}
          style={styles.select}
        />
      </div>

      <div style={styles.row}>
        <Select
          label="Insulation"
          value={wall.insulation}
          onChange={(insulation) => onUpdate({ ...wall, insulation })}
          options={WALL_INSULATION_OPTIONS}
          style={styles.select}
        />
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '6px',
    padding: '10px',
    marginBottom: '8px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#e0e0e0',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  autoTag: {
    background: '#4caf50',
    color: '#fff',
    fontSize: '9px',
    padding: '1px 4px',
    borderRadius: '3px',
    fontWeight: 'normal',
  },
  deleteBtn: {
    color: '#ff6b6b',
    fontSize: '11px',
    padding: '2px 8px',
  },
  row: {
    display: 'flex',
    gap: '8px',
    marginBottom: '6px',
  },
  lengthInput: {
    flex: 1,
  },
  directionSelect: {
    width: '70px',
    flex: 'none',
  },
  select: {
    flex: 1,
  },
};
